import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Avatar_16,
  Avatar_02,
  Avatar_05,
  Avatar_09,
  Avatar_10,
} from "../../../Routes/ImagePath/index";

import { Link } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";

import React, { useState, useEffect } from "react";

import AuthUser from "../../AuthUser";

import { toast, ToastContainer } from "react-toastify";

import Spinner from "../../Spinner";

import Swal from "sweetalert2";

const SubsidioModal = ({ onSubmissionSuccess, subsidio }) => {
  const { t } = useTranslation();

  // eslint-disable-next-line no-unused-vars
  const { http, url_root, user, user_permissoes, verificarPermissao, getMissao } =
    AuthUser();

  const [nome, setName] = useState("");
  const [valor, setValor] = useState(0);
  const [descricao, setDescricao] = useState("");
  const [tipo, setTipo] = useState(1);
  const [natureza, setNatureza] = useState(1);
  const [estado, setEstado] = useState(0);

  const [INSS_coletavel, setINSSColetavel] = useState(1);
  const [IRT_coletavel, setIRTColetavel] = useState(1);
  const [INSS_excedente, setINSSexcedente] = useState(0);
  const [IRT_excedente, setIRTexcedente] = useState(0);

  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const [inputs, setInputs] = useState(subsidio);

  const toggleLoading = (value) => {
    setLoading(value);
  };

  const triggerCloseButtonClick = (buttonId) => {
    const closeButton = document.getElementById(buttonId);
    if (closeButton) {
      closeButton.dispatchEvent(new Event("click"));
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setInputs(subsidio);
        setTipo(inputs?.tipo ? inputs?.tipo : 1);
        setNatureza(inputs?.natureza ? inputs?.natureza : 1);
        setINSSColetavel(inputs?.inss_coletavel ? inputs?.inss_coletavel : 1);
        setIRTColetavel(inputs?.irt_coletavel ? inputs?.irt_coletavel : 1);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [subsidio]);

  //registar tarefa

  const submitFormsubsidio = async () => {
    if (verificarPermissao("CARGO", "adicionar")) {
      try {
        toggleLoading(true);

        // Basic form validation
        if (nome.length < 2) {
          setError("O nome deve ter pelo menos dois caracteres.");
          setLoading(false);

          // Show a error toast
          toast.error("O nome deve ter pelo menos dois caracteres.", {
            position: "top-right",
            autoClose: 3000, // Close the toast after 3 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });

          return;
        }

        await uploadsubsidio();
      } catch (error) {
        if (error.response && error.response.status === 401) {
          setError("Utilizador não autenticado.");

          // Show a error toast
          toast.error("Utilizador não autenticado.", {
            position: "top-right",
            autoClose: 3000, // Close the toast after 3 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        } else {
          setError(
            "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde. Verifique tambem se o e-mail ja esta registado"
          );

          // Show a error toast
          toast.error(
            "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde. Verifique tambem se o e-mail ja esta registado",
            {
              position: "top-right",
              autoClose: 3000, // Close the toast after 3 seconds
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );
        }
      } finally {
        toggleLoading(false);
      }
    } else {
      console.log("Clicou em submeter");

      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const uploadsubsidio = async () => {
    if (verificarPermissao("CARGO", "adicionar")) {
      try {
        const formData = new FormData();
        formData.append("nome", nome);
        formData.append("valor", valor);
        formData.append("descricao", descricao);
        formData.append("tipo", 1);
        formData.append("natureza", natureza);
        formData.append("irt_excedente", IRT_excedente);
        formData.append("inss_excedente", INSS_excedente);
        formData.append("irt_coletavel", IRT_coletavel);
        formData.append("inss_coletavel", INSS_coletavel);
        formData.append("estado", 0);
        formData.append("registou", user?.id);
        formData.append("atualizou", user?.id);
        formData.append('missao_id', getMissao()?.id);

        const response = await http.post("/subsidio/register", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        console.log(response);

        // Show a success toast
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          onClose: () => {
            triggerCloseButtonClick("closeButton30");
            onSubmissionSuccess(response.data.data);
          },
        });
      } catch (error) {
        console.error(error);

        toast.error(
          "Ocorreu um erro ao carregar o utilizador. Por favor, tente novamente mais tarde.",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      }
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  //Update tarefa

  const submitFormUpdate = async () => {
    if (verificarPermissao("CARGO", "atualizar")) {
      try {
        toggleLoading(true);

        // Basic form validation
        if (inputs?.nome.length < 2) {
          setError("O nome deve ter pelo menos dois caracteres.");
          setLoading(false);

          // Show a error toast
          toast.error("O nome deve ter pelo menos dois caracteres.", {
            position: "top-right",
            autoClose: 1000, // Close the toast after 3 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });

          return;
        }

        await updatesubsidio();
      } catch (error) {
        if (error.response && error.response.status === 401) {
          setError("Utilizador não autenticado.");

          // Show a error toast
          toast.error("Utilizador não autenticado.", {
            position: "top-right",
            autoClose: 3000, // Close the toast after 3 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        } else {
          setError(
            "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde. Verifique tambem se o e-mail ja esta registado"
          );

          // Show a error toast
          toast.error(
            "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde. Verifique tambem se o e-mail ja esta registado",
            {
              position: "top-right",
              autoClose: 3000, // Close the toast after 3 seconds
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );
        }
      } finally {
        toggleLoading(false);
      }
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const updatesubsidio = async () => {
    try {

      const formData = new FormData();

      formData.append("id", inputs?.id);
      formData.append("nome", inputs?.nome);
      formData.append("valor", inputs?.valor);
      formData.append("descricao", inputs?.descricao);
      formData.append("tipo", 1);
      formData.append("natureza", natureza);
      formData.append("irt_excedente", inputs?.irt_excedente);
      formData.append("inss_excedente", inputs?.inss_excedente);
      formData.append("irt_coletavel", IRT_coletavel);
      formData.append("inss_coletavel", INSS_coletavel);
      formData.append("atualizou", user?.id);

      const response = await http.post("/subsidio/update", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // Show a success toast
      toast.success(response.data.message, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        onClose: () => {
          triggerCloseButtonClick("closeButton40");
          onSubmissionSuccess(response.data.data);
        },
      });
    } catch (error) {
      console.error(error);

      toast.error(
        "Ocorreu um erro ao carregar o subsidios. Por favor, tente novamente mais tarde.",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    }
  };

  const handleInputsValueChanged = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    setInputs((prevInputs) => ({
      ...prevInputs,
      [name]: value,
    }));
  };

  return (
    <>
      {/* Add Task Modal */}
      <div
        id="add_subsidio_modal"
        className="modal custom-modal fade"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{t("Add subsidio")}</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                id="closeButton30"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="input-block mb-3 form-focus focused">
                  <label className="col-form-label focus-label">
                    {t("Nome Do subsidio")}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={nome}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>

                <div className="input-block mb-3 form-focus focused">
                  <label className="col-form-label focus-label">
                    {t("Valor")}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={valor}
                    onChange={(e) => setValor(e.target.value)}
                  />
                </div>

                <div className="input-block mb-3 form-focus focused">
                  <label className="focus-label">
                    {t("Natureza")} <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control select"
                    onChange={(e) => setNatureza(e.target.value)}
                  >
                    <option value="1">Fixo</option>
                    <option value="2">
                      Percentual ( Baseado no salário base )
                    </option>
                  </select>
                </div>

                <div className="input-block mb-3 form-focus focused">
                  <label className="focus-label">
                    {t("INSS COLETAVEL ?")}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control select"
                    onChange={(e) => setINSSColetavel(e.target.value)}
                    value={INSS_coletavel}
                  >
                    <option value="0">Não</option>
                    <option value="1">SIM</option>
                  </select>
                </div>

                <div className="input-block mb-3 form-focus focused">
                  <label className="col-form-label focus-label">
                    {t("INSS Excedente")}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={INSS_excedente}
                    onChange={(e) => setINSSexcedente(e.target.value)}
                  />
                </div>

                <div className="input-block mb-3 form-focus focused">
                  <label className="focus-label">
                    {t("IRT COLETAVEL ?")}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control select"
                    onChange={(e) => setIRTColetavel(e.target.value)}
                    value={IRT_coletavel}
                  >
                    <option value="0">NÃO</option>
                    <option value="1">SIM</option>
                  </select>
                </div>

                <div className="input-block mb-3 form-focus focused">
                  <label className="col-form-label focus-label">
                    {t("IRT Excedente")}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={IRT_excedente}
                    onChange={(e) => setIRTexcedente(e.target.value)}
                  />
                </div>

                <div className="input-block mb-3 form-focus focused">
                  <label className="col-form-label focus-label">
                    {t("Descrição")}
                  </label>
                  <div className="">
                    <textarea
                      className="form-control"
                      value={descricao}
                      onChange={(e) => setDescricao(e.target.value)}
                    ></textarea>
                  </div>
                </div>

                <div className="submit-section m-t-20 text-center">
                  {loading ? (
                    "A processar"
                  ) : (
                    <a
                      className="btn btn-primary submit-btn"
                      onClick={submitFormsubsidio}
                    >
                      {t("Submit")}
                    </a>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Task Modal */}

      {/* Edit Task Modal */}
      <div
        id="edit_subsidio_modal"
        className="modal custom-modal fade"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{t("Editar subsidio")}</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                id="closeButton40"
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              <form>
                <div className="input-block mb-3 form-focus focused">
                  <label className="col-form-label focus-label">
                    {t("Nome do subsidio")}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="nome"
                    value={inputs?.nome}
                    onChange={(e) => handleInputsValueChanged(e)}
                  />
                </div>

                <div className="input-block mb-3 form-focus focused">
                  <label className="col-form-label focus-label">
                    {t("Valor")}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="valor"
                    value={inputs?.valor}
                    onChange={(e) => handleInputsValueChanged(e)}
                  />
                </div>

                <div className="input-block mb-3 form-focus focused">
                  <label className="focus-label">
                    {t("Natureza")} <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control select"
                    onChange={(e) => setNatureza(e.target.value)}
                    value={natureza}
                  >
                    <option value="1">Fixo</option>
                    <option value="2">
                      Percentual ( Baseado no salário base )
                    </option>
                  </select>
                </div>

                <div className="input-block mb-3 form-focus focused">
                  <label className="focus-label">
                    {t("INSS COLETAVEL ?")}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control select"
                    value={INSS_coletavel}
                    onChange={(e) => setINSSColetavel(e.target.value)}
                  >
                    <option value="0">Não</option>
                    <option value="1">SIM</option>
                  </select>
                </div>

                <div className="input-block mb-3 form-focus focused">
                  <label className="col-form-label focus-label">
                    {t("INSS Excedente")}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="inss_excedente"
                    value={inputs?.inss_excedente}
                    onChange={(e) => handleInputsValueChanged(e)}
                  />
                </div>

                <div className="input-block mb-3 form-focus focused">
                  <label className="focus-label">
                    {t("IRT COLETAVEL ?")}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control select"
                    value={IRT_coletavel}
                    onChange={(e) => setIRTColetavel(e.target.value)}
                  >
                    <option value="0">NÃO</option>
                    <option value="1">SIM</option>
                  </select>
                </div>

                <div className="input-block mb-3 form-focus focused">
                  <label className="col-form-label focus-label">
                    {t("IRT Excedente")}
                  </label>
                  <input
                    type="text"
                    name="irt_excedente"
                    className="form-control"
                    value={inputs?.irt_excedente}
                    onChange={(e) => handleInputsValueChanged(e)}
                  />
                </div>

                <div className="input-block mb-3 form-focus focused">
                  <label className="col-form-label focus-label">
                    {t("Descrição")}
                  </label>
                  <div className="">
                    <textarea
                      name="descricao"
                      className="form-control"
                      value={inputs?.descricao}
                      onChange={(e) => handleInputsValueChanged(e)}
                    ></textarea>
                  </div>
                </div>

                <div className="submit-section m-t-20 text-center">
                  {loading ? (
                    "A processar"
                  ) : (
                    <a
                      className="btn btn-primary submit-btn"
                      onClick={submitFormUpdate}
                    >
                      {t("Save")}
                    </a>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Task Modal */}

      <ToastContainer />
    </>
  );
};

export default SubsidioModal;
